import _ from 'lodash'

export const getControllersOrderedByDependencies = (controllerDependencies: {
	[controllerCompId: string]: Array<string>
}) => {
	const orderedControllers: Array<string> = []
	const visited: { [controllerCompId: string]: boolean } = {}
	const entered: { [controllerCompId: string]: boolean } = {}

	function visit(controllerId: string) {
		if (visited[controllerId] || entered[controllerId]) {
			return
		}
		entered[controllerId] = true
		// eslint-disable-next-line no-unused-expressions
		controllerDependencies[controllerId]?.forEach((depId) => {
			visit(depId)
		})
		visited[controllerId] = true
		orderedControllers.push(controllerId)
	}

	let nextControllerId = _.findKey(controllerDependencies, (__, controllerId) => !visited[controllerId])
	while (nextControllerId) {
		visit(nextControllerId)
		nextControllerId = _.findKey(controllerDependencies, (__, controllerId) => !visited[controllerId])
	}

	return orderedControllers
}
